import { Button, IconButton } from "@mui/material";
import MyBreakcrumbs from "../components/MyBreadcrumbs";
import MyTable from "../components/MyTable";
import React, { useState, useEffect } from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { FaWhatsapp, FaEdit } from "react-icons/fa";
import SearchInput from "../components/SearchInput";
import { getClinicIdFromToken } from "../utils/tokenUtils";
import { fetchInvoiceDataByClinicId } from "../services/api";
import { serviceSendInvoiceDataToWhatsapp } from "../services/billingApi";
import BillingForm from "./BillingForm";
import { jwtDecode } from "jwt-decode";
import CustomSelect from "../components/CustomSelect";
import { StatusOptions } from "../utils/commonData";
import {
  downloadFile,
  formatDateGlobal,
  getStartOrEndOfDay,
} from "../utils/commonUtils";
import "react-datepicker/dist/react-datepicker.css";
import { showToast } from "../utils/toastUtils";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import dayjs from "dayjs";
import AntDatePicker from "../components/antDatepicker";

function Billing() {
  const [selectedStatus, setSelectedStatus] = useState("");
  const [status, setStatus] = useState([]);
  const columns = [
    { Header: "Id", accessor: "id" },
    { Header: "Patient Name", accessor: "patientName" },
    // { Header: "Doctor Name", accessor: "doctorName" },
    {
      Header: "Bill Date",
      accessor: "issued_date", // Make sure this accessor points to the correct date property you want to display
      Cell: ({ value }) => {
        // Assuming the server returns date in UTC and needs to be converted to local time
        return formatDateGlobal(value, {
          currentFormat: "YYYY-MM-DDTHH:mm:ss.SSSZ",
          newFormat: "D MMM, h:mm A",
        });
      },
    },
    {
      Header: "Status",
      accessor: "isInvalidated",
      Cell: ({ value }) => {
        // Determine status based on the value of isInvalidated
        const status = value ? "Invalid" : "Valid";
        setStatus(status)
        return status;
      },
    },
    {
      Header: "Actions",
      Cell: ({ row }) => (
        <>
          <IconButton
            aria-label="view"
            onClick={() => window.open(row.original.url, "_blank")}
          >
            <VisibilityOutlinedIcon />
          </IconButton>
          <IconButton
            aria-label="download"
            color="primary"
            onClick={async () => {
              const url = row?.original?.url;
              const fileName = `Invoice-${row?.original?.invoice_id}`;
              await downloadFile(url, fileName);
            }}
          >
            <FileDownloadOutlinedIcon />
          </IconButton>
          <IconButton
            aria-label="print"
            color="info"
            onClick={() => {
              window.open(row.original.url, "_blank", "noopener,noreferrer");
            }}
          >
            <LocalPrintshopOutlinedIcon />
          </IconButton>
          <IconButton
            aria-label="delete"
            color="success"
            modal="light"
            onClick={() => handleWhatsapp(row.original)}
          >
            <FaWhatsapp />
          </IconButton>
          <button
            className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-1 px-2 rounded-md text-sm"
            onClick={() => {
              handleBillClick(
                row.original.patient.patient_id,
                row.original.invoice_id
              );
            }}
          >
            <FaEdit className="inline mr-1" />
            Edit
          </button>
        </>
      ),
    },
  ];
  const [filterInput, setFilterInput] = useState("");
  const handleFilterChange = (event) => {
    const value = event.target.value || "";
    setFilterInput(value);
  };

  const breadcrumbs = [
    {
      label: "Home",
      href: "#",

      class: "text-[#2E37A4]",
    },
    { label: "Billing", class: "text-[#2E37A4]" },
  ];

  // const Billing = [
  //   {
  //     id: 1,
  //     patientName: "John Doe",
  //     doctorName: "Dr. Smith",
  //     appointmentDate: "2024-02-12",
  //   },
  // ];

  const [Billing, setBilling] = useState([]);
  const token = localStorage.getItem("token");
  const decodedToken = jwtDecode(token);
  const [selectedPatientId, setSelectedPatientId] = useState(null);
  const [showBillingForm, setShowBillingForm] = useState(false);
  const [InvoiceData, setInvoiceData] = useState({});
  const [selectedTab, setSelectedTab] = useState("today");
  const [startDate, setStartDate] = useState(
    dayjs(getStartOrEndOfDay(new Date(), "start"))
  );
  const [endDate, setEndDate] = useState(
    dayjs(getStartOrEndOfDay(new Date(), "end"))
  );

  const handleBillClick = async (patientId, invoiceId) => {
    const selectedInvoiceData = Billing.filter(
      (bill) => bill.id === invoiceId
    )[0];
    // setStatus(status)
    setInvoiceData(selectedInvoiceData);
    setSelectedPatientId(patientId);
    setShowBillingForm(true);
  };

  const handleCloseBillingForm = () => {
    setSelectedPatientId(null);
    setShowBillingForm(false);
  };

  useEffect(() => {
    const clinicId = getClinicIdFromToken();
    //const filters = { startDate, endDate };
    const filters = {
      startDate: getStartOrEndOfDay(startDate, "startdayjs"),
      endDate: getStartOrEndOfDay(endDate, "enddayjs"),
      billstatus: selectedStatus
    };
    fetchInvoiceDataByClinicId(clinicId, filters)
      .then(async (res) => {
        if (res?.status) {
          const filteredBills = await (res?.data || []).filter(
            (bill) => bill?.url !== null
          );
          const formattedBills = await filteredBills.map((bill) => ({
            ...bill,
            id: bill.invoice_id,
            patientName:
              bill.patient.user.first_name + " " + bill.patient.user.last_name,
            // patientName: bill.patientName,
            // doctorName: bill.invoiceItems[0].doctor.user.first_name + " " + bill.invoiceItems[0].doctor.user.last_name,
            appointmentDate: bill?.created_at
              ? new Date(bill?.created_at).toLocaleDateString("en-GB")
              : "N/A", // Formatting date
            url: bill.url,
          }));
          setBilling(formattedBills);
        } else {
          console.error("Failed to fetch bills");
        }
      })
      .catch((error) => console.error("API call failed", error));
  }, [selectedTab, startDate, endDate,selectedStatus]);

  const handleWhatsapp = async (data) => {
    const invoiceData = {
      invoiceId: data.invoice_id,
    };
    const response = await serviceSendInvoiceDataToWhatsapp(invoiceData);
    if (response?.status) {
      showToast(response.message, "success");
    } else {
      showToast(response.message, "error");
    }
  };

  const handleExport = () => {
    if (Billing.length === 0) {
      showToast("No data to export", "error");
      return;
    }
    // Get headers (column names)
    const headers = Object.keys(Billing[0]);

    // Convert reports data to CSV format
    const csvData = Billing.map((report) => {
      return Object.values(report).join(",");
    });

    // Add headers to the start of the csvData array
    csvData.unshift(headers.join(","));

    // Create a blob containing the CSV data
    const blob = new Blob([csvData.join("\n")], {
      type: "text/csv;charset=utf-8;",
    });

    // Create a temporary URL for the blob
    const url = window.URL.createObjectURL(blob);

    downloadFile(url, "billing.csv");
  };

  return (
    <div className="page-container relative h-full flex flex-auto flex-col px-4 sm:px-6 py-4 sm:py-6 md:px-8">
      <div className="pt-2 pb-6 flex justify-between items-center">
        <MyBreakcrumbs data={breadcrumbs} />
        <div className=" inline-flex items-center gap-x-3">
          <Button
            variant={selectedTab === "today" ? "contained" : "outlined"}
            onClick={() => {
              setSelectedTab("today");
              const today = new Date();
              setStartDate(getStartOrEndOfDay(today, "start"));
              setEndDate(getStartOrEndOfDay(today, "end"));
            }}
          >
            Today
          </Button>
          <Button
            variant={selectedTab === "yesterday" ? "contained" : "outlined"}
            onClick={() => {
              setSelectedTab("yesterday");
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              setStartDate(getStartOrEndOfDay(yesterday, "start"));
              setEndDate(getStartOrEndOfDay(yesterday, "end"));
            }}
          >
            Yesterday
          </Button>

          <Button
            variant={selectedTab === "custom" ? "contained" : "outlined"}
            onClick={() => {
              if (selectedTab !== "custom") {
                setSelectedTab("custom");
                const today = new Date();
                setStartDate(getStartOrEndOfDay(today, "start")); // Set start date to today
                setEndDate(getStartOrEndOfDay(today, "end")); // Set end date to today
              }
            }}
          >
            Custom
          </Button>
          {selectedTab === "custom" && (
            <>
              <div>
                <AntDatePicker
                  defaultValue={null}
                  placeholder="select date"
                  value={startDate ? dayjs(startDate) : startDate}
                  onChange={(date, dateString) => {
                    if (endDate && date > endDate) {
                      setEndDate(null);
                    }
                    setStartDate(dateString);
                  }}
                  disabledFutureDate={true}
                  maxDate={dayjs(endDate)}
                />
              </div>
              <div>
                <AntDatePicker
                  defaultValue={null}
                  placeholder="select date"
                  value={endDate ? dayjs(endDate) : endDate}
                  onChange={(date, dateStringE) => {
                    if (startDate && date < startDate) {
                      setStartDate(null);
                    }
                    setEndDate(dateStringE);
                  }}
                  minDate={dayjs(startDate)}
                />
              </div>
            </>
          )}
          <Button
            variant="contained"
            onClick={handleExport}
            style={{ backgroundColor: "#4caf50", color: "white" }}
            startIcon={<CloudDownloadIcon />}
          >
            Export Data
          </Button>
          <SearchInput
            filterInput={filterInput}
            handleFilterChange={handleFilterChange}
          />
        </div>
      </div>

      <div className="flex border-2 border-gray-300 shadow-lg rounded-lg bg-blue-50 mb-6">
        <div className=" flex-1 px-4  py-3">
          <span className="  font-normal"> Start Date: </span>
          <span className=" font-semibold">{formatDateGlobal(startDate)}</span>
        </div>
        <div className=" flex-1 px-4  py-3 ">
          <span className=" font-normal"> Last Date: </span>
          <span className=" font-semibold">{formatDateGlobal(endDate)}</span>
        </div>
        <div className=" flex-1 px-4  py-3 ">
          <span className=" font-normal"> Total Bills: </span>
          <span className=" font-semibold"> {Billing?.length || 0} </span>
        </div>
        <CustomSelect
                value={selectedStatus}
                onChange={(selectedOption) => {
                  setSelectedStatus(selectedOption.value);
                }}
                options={StatusOptions}
                isSearchable={false}
                placeholder="Select Status"
                isClearable={false}
                className="w-48"
              />
      </div>

      <div className=" bg-white rounded-xl shadow-md shadow-gray-200 ">
        <div>
          <div className="px-5 py-3 flex flex-wrap md:flex-nowrap justify-between items-center gap-y-5">
            <div className=" text-lg  font-semibold  text-gray-800">
              Billing
            </div>
          </div>

          <div className=" inline-flex hidden">
            <form className=" relative w-[200px] xl:w-[270px]">
              <input
                type="text"
                className=" h-11  px-5 w-full pl-10 bg-transparent rounded-lg

                  text-gray-900 ring-0 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-0 outline-none focus:ring-inset focus:ring-indigo-600
                  "
                placeholder="Search here"
              />
              <a
                className=" absolute left-2.5 top-2.5"
                href="https://www.app.vitalx.in"
              >
                <img src="images/icons/search-normal.svg" alt="" />
              </a>
            </form>
          </div>
        </div>

        <div className=" overflow-auto px-4">
          <MyTable
            columns={columns}
            data={Billing}
            filterInput={filterInput}
            handleFilterChange={handleFilterChange}
            onBillClick={handleBillClick}
            type="billing"
          />
        </div>
        {/* Render the table */}
      </div>
      {showBillingForm && (
        <BillingForm
          patientId={selectedPatientId}
          invoice_id={InvoiceData.invoice_id}
          onClose={handleCloseBillingForm}
        />
      )}
    </div>
  );
}

export default Billing;
